module.exports = __webpack_public_path__ + "img/question11c3.41f614b2.png";